module.exports = __webpack_public_path__ + "img/spinner.2d7daf3e.gif";